module.exports = __webpack_public_path__ + "img/s-1.1e98099d.png";